import { t } from "i18next";
import { VerificationState } from "backend/datainput";

export const isNotEmpty = (state: VerificationState) => {
  if (!state.field.value) {
    return {
      success: false,
      errorMessages: [t("workflowinput.form.errors.Value can not be empty")],
    };
  }
};

export const isNumber = (state: VerificationState) => {
  if (!/^-?\d*\.?\d*$/.test(state.field.value)) {
    return {
      success: false,
      errorMessages: [t("workflowinput.form.errors.Value must be number")],
    };
  }
};
